import { FormItemLabel, StyledCreateFoodForm } from "./styled"
import TextAreaFieldFormItem from "components/inputs/TextAreaFieldFormItem"
import PortionWithUnitTextField from "components/portion/PortionWithUnitTextField"
import NutrientInformation from "components/foodDetails/share/NutrientInformation"
import ImageUploader from "components/inputs/ImageUploader"
import useGramFromIngredients from "features/food/hooks/useGramFromIngredients"
import { IMyFoodFormModel } from "model/food/types/foodPayload.types"
import { IEdamaIngredientOption } from "model/food/types/edama.types"
import EdamaIngredients from "features/food/CreateMyFood/CreateMyFoodForm/EdamaIngredients"

interface IUpdateFoodFormProps {
  showSearchIngredients: () => void
  food: IMyFoodFormModel
  onNameChange: (name: string) => void
  onPortionChange: (portion: number) => void
  onUnitChange: (unit: string) => void
  onRemoveIngredient: (id: string) => void
  onViewIngredientDetails: (food: IEdamaIngredientOption) => void
  onRemoveImage: () => void
  setIsPortionValid?: (isValid: boolean) => void
}

const UpdateFoodForm = (props: IUpdateFoodFormProps) => {
  const {
    food,
    showSearchIngredients,
    onNameChange,
    onPortionChange,
    onUnitChange,
    onRemoveIngredient,
    onViewIngredientDetails,
    onRemoveImage,
    setIsPortionValid,
  } = props

  const gram = useGramFromIngredients(food)

  return (
    <StyledCreateFoodForm>
      <TextAreaFieldFormItem
        label="Name"
        placeholder="Name your meal"
        value={food.name}
        onChange={onNameChange}
      />

      <PortionWithUnitTextField
        portionValue={food.portion}
        unitValue={food.unit}
        onUnitChange={onUnitChange}
        onPortionChange={onPortionChange}
        setIsPortionValid={setIsPortionValid}
        calories={food.calorie}
        gram={gram}
      />

      <NutrientInformation entry={food} />

      <EdamaIngredients
        showSearchIngredients={showSearchIngredients}
        ingredients={food.ingredients}
        onRemoveIngredient={onRemoveIngredient}
        onViewIngredientDetails={onViewIngredientDetails}
      />

      <div>
        <FormItemLabel>
          Image <span>{"(optional)"}</span>
        </FormItemLabel>
        <ImageUploader onRemoveImage={onRemoveImage} />
      </div>
    </StyledCreateFoodForm>
  )
}

export default UpdateFoodForm
